// Build & download a vCard (.vcf) from the backend-maintained contact data.
function esc(v) {
  return String(v || "").replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");
}

export function buildVCard(c = {}) {
  const company = c.address_line1 || "MF MED GmbH";
  const street = c.address_line2 || "";
  const cityLine = c.address_line3 || "";
  const m = cityLine.match(/^\s*(\d{4,5})\s+(.*)$/);
  const zip = m ? m[1] : "";
  const city = m ? m[2] : cityLine;

  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `FN:${esc(company)}`,
    `ORG:${esc(company)}`,
    c.phone ? `TEL;TYPE=WORK,VOICE:${esc(c.phone)}` : null,
    c.whatsapp ? `TEL;TYPE=CELL:${esc(c.whatsapp)}` : null,
    c.email ? `EMAIL;TYPE=WORK,INTERNET:${esc(c.email)}` : null,
    street || city || zip ? `ADR;TYPE=WORK:;;${esc(street)};${esc(city)};;${esc(zip)};Deutschland` : null,
    c.service_hours ? `NOTE:${esc("Servicezeiten: " + c.service_hours)}` : null,
    "END:VCARD",
  ].filter(Boolean);
  return lines.join("\r\n");
}

export function downloadVCard(contact) {
  const blob = new Blob([buildVCard(contact)], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(contact?.address_line1 || "MF-MED").replace(/[^a-z0-9]+/gi, "-")}.vcf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
